export default "__VITE_ASSET__bwNfeTwh__"